import { Injectable } from '@angular/core';
import {BaseService, httpOptions} from "@core/service/base.service";
import {HttpClient, HttpParams} from "@angular/common/http";
import {Observable} from "rxjs";
import {catchError, tap} from "rxjs/operators";

@Injectable({
  providedIn: 'root'
})
export class ShareSubclassService extends BaseService{

  constructor(http: HttpClient) {
    super(http);
  }
  private url = 'api/share-subclass';
  getUrl(): string {
    return this.url;
  }

  getByMaterial(id):Observable<any> {
    const url = `${this.getUrl()}/get-by/`+id;
    return this.http.get<any>(url).pipe(
      tap(_ => this.log(`getWithItemList`)),
      catchError(this.handleError<any>(`getWithItemList`))
    );
  }

  /** GET from the server */
  page(params:HttpParams):Observable<any> {
    return this.http.get("api/share-subclass-dt",
      {
        headers: httpOptions.headers,
        observe: 'response',//完整数据返回，包括抬头
        params: params
      }
    ).pipe(
      tap(() => this.log('query object')),
      catchError(this.handleError('get any', []))
    );
  }

  deleteBatch(id: any[]): Observable<any> {
    let params = new HttpParams();
    for (let item of id) {
      params = params.append("id", item);
    }
    return this.http.delete<any>("api/share-subclass-dt", {
      headers: httpOptions.headers,
      params: params
    }).pipe(
      tap(_ => this.log(`deleted object list id=${id}`)),
      catchError(this.handleError<any>('delet object list'))
    );
  }
}
